export function useDemo(nameRef) {
    const { $pb } = useNuxtApp();
    let unsubscribe = null;
    
    // Use Nuxt's useAsyncData for data fetching
    const { 
      data: demo, 
      error, 
      pending: loading, 
      refresh 
    } = useAsyncData(
      `demo-${nameRef.value}-${Date.now()}`, // Make key reactive
      async () => {
        try {
          if (!nameRef.value) return null; // Don't fetch if name is null/undefined
          const result = await $pb.collection(COLLECTIONS.DEMO).getFirstListItem(`name="${nameRef.value}"`);
          console.log('Fetched demo:', result);
          return result;
        } catch (e) {
          console.error('Error fetching demo:', e);
          throw createError({
            statusCode: e.status || 500,
            statusMessage: e?.message || 'Failed to fetch demo',
          });
        }
      }
    );
  
    // For real-time updates that aren't covered by useAsyncData
    const localDemo = ref(null);
    
    // Watch for initial data and changes
    watch(demo, (newDemo) => {
      console.log('Demo data updated:', newDemo);
      if (newDemo) {
        localDemo.value = newDemo;
      } else {
        localDemo.value = null;
      }
    }, { immediate: true });
  
    // Subscribe to real-time updates
    const subscribeToChanges = async () => {
      // Only subscribe on client-side and if we have a demo ID
      if (import.meta.client && effectiveDemo.value?.id) {
        try {
          // Unsubscribe from previous demo before subscribing to the new one
          if (unsubscribe) {
            unsubscribe();
            unsubscribe = null;
          }
          unsubscribe = await $pb.collection(COLLECTIONS.DEMO).subscribe(effectiveDemo.value.id, (data) => {
            console.log('Demo updated:', data);
            // Update the local copy
            localDemo.value = data.record;
            // Refresh the cached data
            refresh();
          });
        } catch (e) {
          console.error('Failed to subscribe to demo updates:', e);
        }
      }
    };
  
    // Start subscription
    if (import.meta.client) {
      // Use onMounted to ensure we're on client side
      onMounted(() => {
        subscribeToChanges();
      });
    }
    
    // Clean up subscription when component unmounts
    onUnmounted(() => {
      if (unsubscribe && import.meta.client) {
        unsubscribe();
      }
    });
  
    // Use our local copy that gets both async data and realtime updates
    const effectiveDemo = computed(() => localDemo.value || demo.value);
    console.log(effectiveDemo.value);
  
    // Watch the nameRef and trigger refresh when it changes
    watch(nameRef, (newName) => {
      if (newName) {
        console.log('Demo name changed, refreshing data for:', newName);
        refresh();
      }
    }, { immediate: false }); // Do not run immediately, only on change after initial setup
  
    // Computed property for output frames URLs
    const outputFramesUrls = computed(() => {
      console.log(effectiveDemo.value?.demo);
      if (!effectiveDemo.value?.demo || !Array.isArray(effectiveDemo.value.demo)) {
        return [];
      }
      
      // Limit to maximum 7200 frames and generate URLs for each
      return effectiveDemo.value.demo
        .slice(0, 7200)
        .map(frame => $pb.files.getUrl(effectiveDemo.value, frame));
    });
  
    return {
      demo: effectiveDemo,
      error,
      loading,
      outputFramesUrls,
      refresh,
    };
  }